export default __webpack_public_path__ + "img/olivertree_bedroom-01.16dc07567d6f218c612cc5ae45e52ebc.png";